export const setupFlowStage = [
  'SetupFlowStartStage',
  'DownloadAppStage',
  'TapToPayStage',
  'FeatureOverviewStage',
  'FeaturePaymentsStage',
  'FeatureAccountsStage',
  'FeatureCardsStage',
  'FeatureInvoicesStage',
  'FeatureContactsStage',
] as const

export type SetupFlowStage = (typeof setupFlowStage)[number]

export interface SetupFlowState {
  stage: SetupFlowStage
}
